import { ExportSection } from '../types';
import hasInvalidDecimalPlaces from './hasInvalidDecimalPlaces';
import hasInvalidMaxLength from './hasInvalidMaxLength';

const hasInvalidExportColumnOptions = (sections: ExportSection[]): boolean =>
  hasInvalidDecimalPlaces(sections) || hasInvalidMaxLength(sections);

export default hasInvalidExportColumnOptions;
